var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isReady)?_c('PageHeader',{on:{"selectedLangChange":_vm.initLangChange}}):_vm._e(),(_vm.isReady)?_c('router-view'):_vm._e(),_c('b-loading',{attrs:{"is-full-page":true},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }